<efp-app-header
  [title]="(title$ | async) || ''"
  [navLink]="navLink"
  [backNavOptions]="backNavOptions"></efp-app-header>

<efp-sidebar-container
  [sidebarPosition]="SidebarPosition.LEFT"
  efpKeyboardShortcut
  (enterShortcut)="onEnter()">
  <efp-primary-menu leftSidebar class="media-web-only"></efp-primary-menu>
  <efp-center-container
    [fullHeight]="true"
    [displayFlex]="true"
    [bottomPaddingForFloatingButton]="true"
    [showSafeArea]="false">
    <efp-page-heading> {{ title$ | async}} </efp-page-heading>

    <ng-container *ngIf="filteredStocks$ | async as stocks">
      <ion-list *ngIf="stocks.length > 0">
        <div class="mobile-container full-width">
          <ng-container *ngFor="let stock of stocks">
            <efp-stock-list-item
              [stock]="stock"
              (showStockEvent)="showStock($event)"
              (deleteStock)="deleteStock($event)"
              (shareStock)="shareStock($event)"
              (renameStock)="presentRenameStockAlert($event)"></efp-stock-list-item>
          </ng-container>
        </div>
      </ion-list>
    </ng-container>

    <div class="d-flex efp-floating-button-container safe-area-bottom" *ngIf="showButtons">
      <button
        class="button button-secondary"
        (click)="importStock(stockFile)"
        data-test-selector="stock-import">
        <ion-icon src="/assets/icon/import.svg"></ion-icon>
        <span>{{'STOCK.IMPORT' | translate}}</span>
      </button>

      <button class="button button-primary" (click)="createStock()" data-test-selector="stock-add">
        <span class="button-icon">add</span>
        {{'STOCK.ADD' | translate}}
      </button>
    </div>
    <input
      #stockFile
      type="file"
      class="ion-hide"
      accept=".ma7, .csv"
      (change)="readFile(stockFile)" />
  </efp-center-container>
</efp-sidebar-container>
